import script from "./setPrivateTime.vue?vue&type=script&setup=true&lang=js"
export * from "./setPrivateTime.vue?vue&type=script&setup=true&lang=js"

import "./setPrivateTime.vue?vue&type=style&index=0&id=10112b5a&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10112b5a"]])

export default __exports__